import { object, number, string, boolean, array } from "yup";
import {
  customTagResourceSchema,
  CustomTagResource,
} from "@client/resources/CustomTagResource";

interface DietitianDto {
  id: number;
  name: string | null;
}

interface ProgramStatusDto {
  id: number;
}

interface ProgramDto {
  id: number;
  startedAt: string;
  finishedAt: string;
  status: ProgramStatusDto;
}

interface ScheduleStatusDto {
  id: number;
}

interface ScheduleDto {
  id: number;
  startedAt: string;
  status: ScheduleStatusDto;
}

interface ProfileDto {
  dietitian?: DietitianDto | null;
  program: ProgramDto | null;
  schedule: ScheduleDto | null;
}

interface ChatDto {
  active: boolean;
}

export interface PatientListNewResource {
  id: number;
  name: string;
  email: string | null;
  isActive: boolean;
  isMobileAppActive: boolean;
  activeUntil: string | null;
  avatar: string | null;
  profile: ProfileDto;
  tags: CustomTagResource[];
  chat: ChatDto;
  isActiveInCurrentPeriod: boolean;
}

const idSchema = object().shape({
  id: number().required(),
});

const idNullableNameSchema = object().shape({
  id: number().required(),
  name: string().nullable().defined(),
});

const programStatusSchema = object().shape({
  id: number().required(),
});

const scheduleStatusSchema = object().shape({
  id: number().required(),
});

const profileProgramSchema = object().shape({
  id: number().required(),
  startedAt: string().required(),
  finishedAt: string().required(),
  status: programStatusSchema.required(),
});

const profileScheduleSchema = object().shape({
  id: number().required(),
  startedAt: string().required(),
  status: scheduleStatusSchema.required(),
});

const profileSchema = object().shape({
  dietitian: idNullableNameSchema.nullable(),
  program: profileProgramSchema.nullable(),
  schedule: profileScheduleSchema.nullable(),
});

export const patientListNewResourceSchema = object().shape({
  id: number().required(),
  name: string().required(),
  email: string().nullable().defined(),
  isActive: boolean().required(),
  isMobileAppActive: boolean().required(),
  activeUntil: string().nullable().defined(),
  avatar: string().nullable().defined(),
  profile: profileSchema.required(),
  tags: array().of(customTagResourceSchema).required(),
  chat: object().shape({
    active: boolean().required(),
  }),
  isActiveInCurrentPeriod: boolean().required(),
});
